import {
  createContext,
  useCallback,
  useContext,
  useRef,
  useState,
  type ReactNode,
} from "react";

interface ToastContextValue {
  showToast: (message: string) => void;
}

const ToastContext = createContext<ToastContextValue>({ showToast: () => {} });

export const useToast = () => useContext(ToastContext);

export function ToastProvider({ children }: { children: ReactNode }) {
  const [message, setMessage] = useState<string | null>(null);
  const timerRef = useRef<number | null>(null);

  const showToast = useCallback((msg: string) => {
    setMessage(msg);
    if (timerRef.current) {
      window.clearTimeout(timerRef.current);
    }
    timerRef.current = window.setTimeout(() => setMessage(null), 2600);
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {message !== null && (
        <div className="fixed bottom-8 left-1/2 z-[100] flex max-w-[90vw] -translate-x-1/2 animate-fade-up items-center gap-2 rounded-full border border-accent-500/40 bg-background-100 px-5 py-3 text-sm text-foreground-950 shadow-lg">
          <i className="ri-information-line text-lg text-accent-500"></i>
          <span className="whitespace-nowrap">{message}</span>
        </div>
      )}
    </ToastContext.Provider>
  );
}